import { useTranslation } from '@repo/i18n/react';
import { ThemeProvider } from '@repo/ui/providers/theme-provider';
import { TooltipProvider } from '@repo/ui/tooltip';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { type LoaderFunctionArgs, Outlet, useLoaderData } from 'react-router';
import { Toaster } from 'sonner';
import { getSession } from './lib/auth-req';
import { SessionProvider } from './providers/session';
import { TrpcProvider } from './providers/trpc';

const loader = async ({ request }: LoaderFunctionArgs) => {
  const session = await getSession(request);
  return { session };
};

export { loader as rootLoader };
export type RootLoader = Awaited<ReturnType<typeof loader>>;

const Root = () => {
  const { direction } = useTranslation();

  const { session } = useLoaderData<typeof loader>();
  return (
    <NuqsAdapter>
      <TrpcProvider
        apiUrl={process.env.BUN_PUBLIC_API_URL || ''}
        trpcEndpoint={process.env.BUN_PUBLIC_TRPC_ENDPOINT ?? ''}
      >
        <SessionProvider
          initialSession={
            session.session && session.user
              ? { session: session.session, user: session.user }
              : null
          }
        >
          <TooltipProvider>
            <ThemeProvider>
              <Outlet />
            </ThemeProvider>
            <Toaster dir={direction} />
          </TooltipProvider>
        </SessionProvider>
      </TrpcProvider>
    </NuqsAdapter>
  );
};

export default Root;
